"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageOpportunityGroupCommandType = exports.CoverageOpportunityGroupCommandStatusReason = exports.CoverageOpportunityGroupCommandStatus = void 0;
var CoverageOpportunityGroupCommandStatus;
(function (CoverageOpportunityGroupCommandStatus) {
    CoverageOpportunityGroupCommandStatus["PENDING"] = "PENDING";
    CoverageOpportunityGroupCommandStatus["COMPLETED"] = "COMPLETED";
})(CoverageOpportunityGroupCommandStatus = exports.CoverageOpportunityGroupCommandStatus || (exports.CoverageOpportunityGroupCommandStatus = {}));
var CoverageOpportunityGroupCommandStatusReason;
(function (CoverageOpportunityGroupCommandStatusReason) {
    CoverageOpportunityGroupCommandStatusReason["FAILED"] = "FAILED";
    CoverageOpportunityGroupCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
})(CoverageOpportunityGroupCommandStatusReason = exports.CoverageOpportunityGroupCommandStatusReason || (exports.CoverageOpportunityGroupCommandStatusReason = {}));
var CoverageOpportunityGroupCommandType;
(function (CoverageOpportunityGroupCommandType) {
    CoverageOpportunityGroupCommandType["ARCHIVE"] = "ARCHIVE";
    CoverageOpportunityGroupCommandType["CHANGE_ACCOUNT"] = "CHANGE_ACCOUNT";
    CoverageOpportunityGroupCommandType["CREATE"] = "CREATE";
    CoverageOpportunityGroupCommandType["CREATE_WITHOUT_COVERAGE_OPPORTUNITIES"] = "CREATE_WITHOUT_COVERAGE_OPPORTUNITIES";
    CoverageOpportunityGroupCommandType["UNARCHIVE"] = "UNARCHIVE";
    CoverageOpportunityGroupCommandType["UPDATE_DISPLAY_NAME"] = "UPDATE_DISPLAY_NAME";
    CoverageOpportunityGroupCommandType["UPDATE_HISTORICAL_DETAILS"] = "UPDATE_HISTORICAL_DETAILS";
    CoverageOpportunityGroupCommandType["UPDATE_NOTES"] = "UPDATE_NOTES";
    CoverageOpportunityGroupCommandType["UPDATE_REQUESTED_DETAILS"] = "UPDATE_REQUESTED_DETAILS";
})(CoverageOpportunityGroupCommandType = exports.CoverageOpportunityGroupCommandType || (exports.CoverageOpportunityGroupCommandType = {}));
//# sourceMappingURL=coverage-opportunity-group-command.js.map